import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SectionStyled = styled.section`
  border-radius: 10px;
  background-color: ${colors.neutral.white};
  padding: 2.4rem 4rem;
`;
